/**
 * Coid 2.0 server
 * Coid 2.0 server API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum AccreditationFeatureType {
    AUTHORITY_MATRIX = 'AUTHORITY_MATRIX',
    ACCOUNT_PREVALIDATION = 'ACCOUNT_PREVALIDATION',
    IDENTIFICATIONS_WITHOUT_DATA = 'IDENTIFICATIONS_WITHOUT_DATA',
    IDENTIFICATIONS_WITH_DATA = 'IDENTIFICATIONS_WITH_DATA',
    IDENTIFICATIONS_WITH_DATA_WITHOUT_OTP = 'IDENTIFICATIONS_WITH_DATA_WITHOUT_OTP',
    IDENTIFICATIONS_WITH_DATA_B2C2I = 'IDENTIFICATIONS_WITH_DATA_B2C2I',
    ESIGNS = 'ESIGNS',
    ORGANIZATION_ESIGNS = 'ORGANIZATION_ESIGNS',
    GET_ACCOUNTS = 'GET_ACCOUNTS',
    GET_ACCOUNTS_V2 = 'GET_ACCOUNTS_V2',
    GET_ACCOUNTS_V3 = 'GET_ACCOUNTS_V3',
    PROVIDE_ACCOUNTS = 'PROVIDE_ACCOUNTS',
    PROVIDE_ACCOUNTS_V2 = 'PROVIDE_ACCOUNTS_V2',
    PROVIDE_ACCOUNTS_V3 = 'PROVIDE_ACCOUNTS_V3',
    GET_ACCOUNT_BALANCES = 'GET_ACCOUNT_BALANCES',
    GET_ACCOUNT_BALANCES_V2 = 'GET_ACCOUNT_BALANCES_V2',
    GET_ACCOUNT_BALANCES_V3 = 'GET_ACCOUNT_BALANCES_V3',
    PROVIDE_ACCOUNT_BALANCES = 'PROVIDE_ACCOUNT_BALANCES',
    PROVIDE_ACCOUNT_BALANCES_V2 = 'PROVIDE_ACCOUNT_BALANCES_V2',
    PROVIDE_ACCOUNT_BALANCES_V3 = 'PROVIDE_ACCOUNT_BALANCES_V3',
    GET_ACCOUNT_TRANSACTIONS = 'GET_ACCOUNT_TRANSACTIONS',
    GET_ACCOUNT_TRANSACTIONS_V2 = 'GET_ACCOUNT_TRANSACTIONS_V2',
    GET_ACCOUNT_TRANSACTIONS_V3 = 'GET_ACCOUNT_TRANSACTIONS_V3',
    PROVIDE_ACCOUNT_TRANSACTIONS = 'PROVIDE_ACCOUNT_TRANSACTIONS',
    PROVIDE_ACCOUNT_TRANSACTIONS_V2 = 'PROVIDE_ACCOUNT_TRANSACTIONS_V2',
    PROVIDE_ACCOUNT_TRANSACTIONS_V3 = 'PROVIDE_ACCOUNT_TRANSACTIONS_V3',
    GET_TAX_INCOME = 'GET_TAX_INCOME',
    PROVIDE_TAX_INCOME = 'PROVIDE_TAX_INCOME',
    C2C2_TRANSFERS_RECEIVE = 'C2C2_TRANSFERS_RECEIVE',
    C2C2_TRANSFERS_SEND = 'C2C2_TRANSFERS_SEND',
    C2CR_RETURN_TRANSFERS_RECEIVE = 'C2CR_RETURN_TRANSFERS_RECEIVE',
    C2CR_RETURN_TRANSFERS_SEND = 'C2CR_RETURN_TRANSFERS_SEND',
    C2CR_RTP_RETURN_TRANSFERS_RECEIVE = 'C2CR_RTP_RETURN_TRANSFERS_RECEIVE',
    C2CR_RTP_RETURN_TRANSFERS_SEND = 'C2CR_RTP_RETURN_TRANSFERS_SEND',
    M2M_TRANSFERS_RECEIVE = 'M2M_TRANSFERS_RECEIVE',
    M2M_TRANSFERS_SEND = 'M2M_TRANSFERS_SEND',
    C2B2_PAYMENTS_RECEIVE = 'C2B2_PAYMENTS_RECEIVE',
    C2B2_PAYMENTS_SEND = 'C2B2_PAYMENTS_SEND',
    C2B2_RTP_PAYMENTS_SEND = 'C2B2_RTP_PAYMENTS_SEND',
    C2B2_RTP_PAYMENTS_RECEIVE = 'C2B2_RTP_PAYMENTS_RECEIVE',
    C2B2_V2_PAYMENTS_RECEIVE = 'C2B2_V2_PAYMENTS_RECEIVE',
    C2B2_V2_PAYMENTS_SEND = 'C2B2_V2_PAYMENTS_SEND',
    C2B2E_PAYMENTS_RECEIVE = 'C2B2E_PAYMENTS_RECEIVE',
    C2B2E_PAYMENTS_SEND = 'C2B2E_PAYMENTS_SEND',
    C2BR_RETURN_PAYMENTS_RECEIVE = 'C2BR_RETURN_PAYMENTS_RECEIVE',
    C2BR_RETURN_PAYMENTS_SEND = 'C2BR_RETURN_PAYMENTS_SEND',
    C2BR_V2_RETURN_PAYMENTS_RECEIVE = 'C2BR_V2_RETURN_PAYMENTS_RECEIVE',
    C2BR_V2_RETURN_PAYMENTS_SEND = 'C2BR_V2_RETURN_PAYMENTS_SEND',
    C2BRM_V2_RETURN_PAYMENTS_RECEIVE = 'C2BRM_V2_RETURN_PAYMENTS_RECEIVE',
    C2BRM_V2_RETURN_PAYMENTS_SEND = 'C2BRM_V2_RETURN_PAYMENTS_SEND',
    C2BRE_RETURN_PAYMENTS_RECEIVE = 'C2BRE_RETURN_PAYMENTS_RECEIVE',
    C2BRE_RETURN_PAYMENTS_SEND = 'C2BRE_RETURN_PAYMENTS_SEND',
    B2C2I_PAYOUTS_SEND = 'B2C2I_PAYOUTS_SEND',
    B2C2I_PAYOUTS_RECEIVE = 'B2C2I_PAYOUTS_RECEIVE',
    B2C2U_PAYOUTS_SEND = 'B2C2U_PAYOUTS_SEND',
    B2C2U_PAYOUTS_RECEIVE = 'B2C2U_PAYOUTS_RECEIVE',
    IDENTITY = 'IDENTITY',
    IDENTITY_DATA = 'IDENTITY_DATA'
}

